import { Link, useLocation, useNavigate } from "react-router-dom";

const DEFAULT_CLASSNAMES = {
  container:
    "decoration-primary uppercase bg-secondary cursor-pointer hover:underline text-white font-ubuntuRegular rounded px-2 py-1 flex items-center",
  currentContainer:
    "text-white uppercase border-animate cursor-pointer font-ubuntuRegular bg-primary rounded px-2 py-1 flex items-center",
  link: "",
  currentLink: "",
};

const NavLink = ({
  to = "/",
  classNames = DEFAULT_CLASSNAMES,
  children,
  ...props
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isCurrent = location.pathname.includes(to);

  const handleClick = () => {
    navigate(to);
  };
  return (
    <div
      className={
        isCurrent
          ? classNames?.currentContainer || DEFAULT_CLASSNAMES.currentContainer
          : classNames?.container || DEFAULT_CLASSNAMES.container
      }
      onClick={handleClick}
    >
      <Link
        className={
          isCurrent
            ? classNames?.currentLink || DEFAULT_CLASSNAMES.currentLink
            : classNames?.link || DEFAULT_CLASSNAMES.link
        }
        to={to}
        {...props}
      >
        {children}
      </Link>
    </div>
  );
};

export default NavLink;
